export default "__VITE_ASSET___oQ70TC___"